import { createResourceApi } from 'resources/ResourceApi';
import { HighlightApiItem } from 'typings/api';

export default createResourceApi<HighlightApiItem>('highlights');
